export default __webpack_public_path__ + "static/media/ly.a95222de.svg";